import {
  IconInterface,
  NotificationPositionType,
  NotificationTheme,
} from '@avla/ui-design/commons';
import { environment } from 'src/environments/environment';

export enum ROUTESPATH {
  // PUBLIC
  LOGIN = 'login',
  PUBLIC_ADMIN = 'public-admin/:key',
  // PRIVATE
  HOME = 'home',
  POLICY = 'policy',
  PROJECT = 'project',
  REPORTS = 'reports',
  CREATE_USER = 'create-user',
  EMAIL_LIST = 'email-list',

  // POLICY
  POLICIES = 'policies',
  CREATE = 'create',
  POLICY_POLICIES = 'policy/policies',
  POLICY_CREATE = 'policy/create',

  // POLICY/CREATE
  CREAR_POLIZA = 'crear-poliza',
  UNA_A_UNA = 'una-a-una/:idPolicyData',
  UNA_A_UNA_EDIT = 'una-a-una/edit/:idPolicyData',
  PAYMENT_SCHEDULE = 'payment-schedule/:idPolicyData',
  PAYMENT_SCHEDULE_EDIT = 'payment-schedule/edit/:idPolicyData',
  VALIDATION = 'validacion',
  CONFIRM = 'confirm',
  EMISSION = 'emission',
  POLICY_CREATE_CREAR_POLIZA = 'policy/create/crear-poliza',
  POLICY_CREATE_UNA_A_UNA = 'policy/create/una-a-una/:idPolicyData',
  POLICY_CREATE_UNA_A_UNA_EDIT = 'policy/create/una-a-una/edit/:idPolicyData',
  POLICY_CREATE_PAYMENT_SCHEDULE = 'policy/create/payment-schedule/:idPolicyData',
  POLICY_CREATE_PAYMENT_SCHEDULE_EDIT = 'policy/create/payment-schedule/edit/:idPolicyData',
  POLICY_CREATE_VALIDATION = 'policy/create/validacion',
  POLICY_CREATE_CONFIRM = 'policy/create/confirm',
  POLICY_CREATE_EMISSION = 'policy/create/emission',

  // PROJECT
  PROYECTOS_GENERAL = 'general/:idProject',
  MIS_PROYECTOS = 'mis-proyectos',
  COSTS_AND_FINANCING = 'costs-and-financing/:idProject',
  CLIENT = 'client/:idProject',
  DETAIL = 'detail/:idProject',
  DOCUMENTATION = 'documentation/:idProject',
  RESULT = 'result/:idProject',
  PROJECT_PROYECTOS_GENERAL = 'project/general/:idProject',
  PROJECT_MIS_PROYECTOS = 'project/mis-proyectos',
  PROJECT_COSTS_AND_FINANCING = 'project/costs-and-financing/:idProject',
  PROJECT_CLIENT = 'project/client/:idProject',
  PROJECT_DETAIL = 'project/detail/:idProject',
  PROJECT_DOCUMENTATION = 'project/documentation/:idProject',
  PROJECT_RESULT = 'project/result/:idProject',

  // REPORTS
  MIS_POLIZAS = 'mis-polizas',
  PRIMAS_PENDIENTES = 'primas-pendientes',
  COMISIONES = 'comisiones',
  REPORTS_MIS_POLIZAS = 'reports/mis-polizas',
  REPORTS_PRIMAS_PENDIENTES = 'reports/primas-pendientes',
  REPORTS_COMISIONES = 'reports/comisiones',
  CHANGE_PASSWORD = 'changePassword/:token',
}

export const BASE_URL = `${environment.API_PROTOCOL}${environment.API_HOST}${environment.API_PORT}${environment.API_PREFIX}`;

export enum ENDPOINTS {
  BASIC_INFORMATION = '/v1/BasicInformation',
  BENEFICIARY = '/v1/beneficiary',
  CHANGE_PASSWORD = '/v1/ChangePassword',
  RECOVER_EMAIL = '/v1/RecoverEmail',
  CREATE_ACCOUNT = '/v1/Notification/register',
  COMPANY_AFFILIATES = '/v1/Company/Affiliates/:rut',
  COMUNA = '/v1/Comuna',
  CONFIRM = '/v1/confirm',
  DELETE_PAYMNET_SCHEDULE = '/v1/Policy/paymentSchedule/:id',
  DELETE_ALL_PAYMNET_SCHEDULE = '/v1/Policy/paymentSchedule/all/:idPolicyData',
  DETAIL_COMPANY = '/v1/Policy/cotization/detailCompany',
  DETAIL_PROJECT = '/v1/Policy/cotization/detailProject/:idProject',
  DELETE_POLICY = '/v1/Policy/validation/:idPolicyData',
  FLOW_GET_TOKEN = '/v1/Policy/flow/token',
  SAVED_POLICY_DATA = '/v1/Policy/policyData',
  LOGIN = '/v1/login',
  LOGOUT = '/v1/logOut',
  UPDATESTATUSPOLICIES = '/v1/updateStatusPolicies',
  PAYMENT_SCHEDULE = '/v1/Policy/paymentSchedule',
  PAYMENT_SCHEDULE_VALIDATION = '/v1/Policy/paymentSchedule/validation',
  PERIODIC_PAYMENT = '/v1/Policy/paymentSchedule/periodicPayment',
  PERSON_TYPE = '/v1/PersonType',
  PROJECT_GENERAL = '/v1/Project/general/:IdProject',
  PROJECT_INFO = '/v1/Project/info',
  PROJECTS = '/v1/Project',
  POLICES_VALIDATION_ALL = '/v1/Policy/validation/getAll',
  POLICIES_DELETE_ALL = '/v1/Policy/validation/AllData/:idProject',
  REGION = '/v1/Region',
  USER_POLICIES = '/v1/Policy/getAll',
  COMMISSIONS = '/v1/Policy/commissions',
  DETAILS_PROJECT = '/v1/project/:id',
  USER_PROJECTS = '/v1/project/projectsByTaker',
  VALIDATION_ALL = '/v1/Policy/validation',
  GET_CLIENT = '/v1/Project/Client',
  GET_AFFILIATES = '/v1/Company/Affiliates',
  CLIENT = '/v1/Project/client',
  DETAIL = '/v1/Project/detail',
  COSTS_AND_FINANCING = '/v1/Project/CostFinancing',
  DOCUMENTS = '/v1/Project/Documents/:idProject',
  DOCUMENT = '/v1/Project/Document/:idDocument',
  DOCUMENT_UPLOADISOK = '/v1/Project/Document/uploadIsOk/:idProject',
  DOCUMENT_MANUAL = '/v1/Project/Documents/manualResolution/:idProject',
  DOCUMENT_SAVE_MINUTA = '/v1/Project/Document/saveMinuteDocument',
  FILEUPLOAD = '',
  EMIT_POLICY = '/v1/Policy/emit',
  RESULT = '/v1/Project/result/:idProject',
  POLICY_MASSIVE_LOAD = '/v1/Policy/loadMassive',
  POLICY_MASSIVE_LOAD_CHECK = '/v1/Policy/loadMassive/check',
  POLICY_PAYMENT_SCHEDULE_PATCH = '/v1/Policy/paymentSchedule/:idPaymentSchedule',
  TAKER_NEW = '/v1/Taker/new/:rut',
  POLICY_DOWNLOAD_BASE64 = '/v1/download/policy/base64/:id',
  DOWNLOAD_MODELO_BASE64 = '/v1/download/modelo/base64/',
  DOWNLOAD_MY_POLICY_BASE64 = '/v1/download/policy/all/base64',
  USERS = '/v1/user',
  ROLES = '/v1/role',
  USER_HELP = '/v1/user/help/tours',
  VALID_TOKEN = '/v1/Token/Valid',
  CONTRACT_URL = '/v1/Contract/contractUrl',
  READ_DOCUMENTO = '/v1/ReadDocument/askDocument/:idDocument',
  GET_URL_DOCUMENT = '/v1/ReadDocument/geturlDocument',
  SAVED_DOCUMENT = '/v1/ReadDocument/savedDocument',
  EMAIL_LIST = '/v1/emailToSendPolicy',

  RECOVER_PASSWORD = '/v1/password/recovery',
  CHANGE_PASSWORD_WITH_TOKEN = '/v1/password/change',
}

export enum MESSAGES {
  EXTENSION_NOT_SET = 'Extensión de archivo no permitida',
  VALIDATION_SUCCESS = 'Ya puedes continuar para ver tu cotización',
}

interface NotificationGlobalConfig {
  POSITION: NotificationPositionType;
  ICON_WARN_NOT: IconInterface;
  ICON_ERROR_NOT: IconInterface;
  ICON_SUCCESS_NOT: IconInterface;
  ICON_INFO_NOT: IconInterface;
  ICON_CLOSE_NOT: IconInterface;
  THEME_WARN_NOT: NotificationTheme;
  THEME_ERROR_NOT: NotificationTheme;
  THEME_SUCCESS_NOT: NotificationTheme;
  THEME_INFO_NOT: NotificationTheme;
}

export const NOT_CONFIG: NotificationGlobalConfig = {
  POSITION: 'top-right',
  ICON_WARN_NOT: {
    icon: 'circle_notifications',
    type: 'class',
    class: 'material-symbols-rounded',
  },
  ICON_ERROR_NOT: {
    icon: 'cancel',
    type: 'class',
    class: 'material-symbols-rounded',
  },
  ICON_SUCCESS_NOT: {
    icon: 'task_alt',
    type: 'class',
    class: 'material-symbols-rounded',
  },
  ICON_INFO_NOT: {
    icon: 'info',
    type: 'class',
    class: 'material-symbols-rounded',
  },
  ICON_CLOSE_NOT: {
    icon: 'close',
    type: 'class',
    class: 'material-symbols-rounded',
  },
  THEME_WARN_NOT: 'warn',
  THEME_ERROR_NOT: 'error',
  THEME_SUCCESS_NOT: 'success',
  THEME_INFO_NOT: 'info',
};

export const START_DAYS: number = 90;
export const START_MAX_DAYS: number = 60;
export const TIME_ZONE = 'America/Santiago';
